import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '@/lib/auth/route-guards'
import type { RouterAuthContext } from '@/lib/auth/router-context'

/**
 * Layout route for curriculum section
 * Renders child routes via Outlet
 */
function CurriculumLayout() {
  return <Outlet />
}

export const Route = createFileRoute('/app/curriculum')({
  beforeLoad: async ({ context, location }) => {
    await requirePermission(context as RouterAuthContext, 'curriculum:view', {
      currentPath: location.pathname,
    })
  },
  component: CurriculumLayout,
})
